/**
 * OVERRIDE VideoSidebar.jsx
 * REASON: Route field changes through dataAdapter to enforce default block width when floating.
 * DATE: 2026-04-16
 * DEVELOPER: @danalvrz
 */

import VideoSidebar from '../../../../../../components/Blocks/Video/VideoSidebar';

export default VideoSidebar;
